var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRubyrollIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76758 3.8958C6.63795 3.72167 6.36191 3.72167 6.23244 3.8958L3.30786 7.8268C3.23036 7.93098 3.23036 8.06908 3.30786 8.17324L6.23244 12.1042C6.36191 12.2784 6.63795 12.2784 6.76758 12.1042L9.69213 8.17324C9.76965 8.06908 9.76965 7.93098 9.69213 7.8268L6.76758 3.8958ZM7.97173 0.718314C7.25924 -0.239438 5.74079 -0.239438 5.0283 0.718313L0.319656 7.04734C-0.106552 7.62025 -0.106552 8.37981 0.319656 8.9527L5.0283 15.2818C5.74079 16.2394 7.25924 16.2394 7.97173 15.2818L12.6804 8.9527C13.1065 8.37981 13.1065 7.62025 12.6804 7.04734L7.97173 0.718314Z",
    fill: "#F00F38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyrollIcon);
export default __webpack_public_path__ + "static/media/rubyroll-icon.0636063b0927de406d8903bb3ae38bd6.svg";
export { ForwardRef as ReactComponent };